import { DataGridLayout, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import { BooleanField, FullDateField, SearchLinkField, TextField } from 'framework/ui/field';
import { CREATE_PROJECT, UPDATE_PROJECT, useProjectUrl, useProjectService } from 'domain/shared/project';
import EditProjectButton from 'domain/projects/project/List/button/EditProjectButton';
import { BudgetLinkField } from 'domain/shared/budget';
import { useWasteUrl, CREATE_WASTE } from 'domain/shared/waste';
import ProjectsStaticFilters from './filter/ProjectsStaticFilters';

const ProjectList = () => {
  const { search } = useProjectService();
  const { getCreateUrl, getSingleEntityUrl } = useProjectUrl();
  const { getCreateUrl: getWasteCreateUrl } = useWasteUrl();

  return (
    <List getDataMethod={search} defaultSortOrder="DESC" defaultSortField="updatedAt">
      <ListPageLayout
        header={<ProjectsStaticFilters title={<ListHeader label="Projects" icon="fa-folder-o" />} />}
        actions={[
          <CreateButton
            url={getWasteCreateUrl()}
            label="Report Waste"
            key="create-waste"
            permissionToCheck={CREATE_WASTE}
          />,
          <CreateButton
            url={getCreateUrl()}
            label="Create Project"
            key="create-project"
            permissionToCheck={CREATE_PROJECT}
          />,
        ]}
        search={<SearchInput label="project name" />}
      >
        <DataGridLayout
          buttons={[<EditProjectButton key="edit-project" source="id" outline permissionToCheck={UPDATE_PROJECT} />]}
        >
          <SearchLinkField source="id" label="Project ID" url={getSingleEntityUrl} isSortable width={140} />
          <TextField source="name" label="Project Name" isSortable />
          <BudgetLinkField
            label="Default Budget"
            source="defaultBudgetId"
            nameSource="defaultBudget.name"
            width={140}
          />
          <TextField source="sowId" label="SOW Number" isSortable />
          <FullDateField source="updatedAt" label="Last Modified Date" isSortable />
          <BooleanField source="assignmentForbidden" label="Assignment Forbidden" isSortable />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ProjectList;
